<template>
  <dialog-wrapper :visible="dialog">
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="pb-0">
          <h3 class="headline mb-0">{{ $t('mainComponent.rateLunchOn', { date: date, providerTitle: providerTitle }) }}</h3>
          <div v-t="'mainComponent.rateLunchSubtitle'" />
        </v-card-title>
        <v-list>
          <template v-for="dish in ratedDishes">
            <v-list-tile :key="dish.id" avatar>
              <v-list-tile-avatar>
                <v-tooltip v-if="!dish.isSoup" bottom class="mt-2">
                  <span slot="activator">
                    <v-icon color="secondary">restaurant</v-icon>
                  </span>
                  <span>{{ dish.title }}</span>
                </v-tooltip>
                <v-tooltip v-if="dish.isSoup" bottom class="mt-2">
                  <span slot="activator">
                    <v-icon color="secondary">mdi-bowl</v-icon>
                  </span>
                  <span>{{ dish.title }}</span>
                </v-tooltip>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-layout>
                  <v-btn
                    v-for="(button, index) in buttons"
                    :key="index"
                    class="rating-button mt-3"
                    style="margin:0"
                    flat
                    fab
                    small
                    @click="dish.rating = button.value"
                    @mouseover="hovered = `${button.value}-${dish.id}`"
                    @mouseout="hovered = ''"
                  >
                    <v-icon
                      :color="(hovered === `${button.value}-${dish.id}` || button.value === dish.rating) ? 'secondary' : ''"
                      style="font-size:2em"
                    >{{ button.icon }}</v-icon>
                  </v-btn>
                  <v-text-field
                    v-if="!$vuetify.breakpoint.smAndDown"
                    ref="comment"
                    v-model="dish.comment"
                    class="ml-3"
                    :label="$t('mainComponent.comment')"
                    :rules="[rules.lengthNotGreaterThan]"
                  />
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="$vuetify.breakpoint.smAndDown" :key="`a-${dish.id}`">
              <v-list-tile-content>
                <v-text-field
                  ref="comment"
                  v-model="dish.comment"
                  class="ml-3 pr-3"
                  :label="$t('mainComponent.comment')"
                  :rules="[rules.lengthNotGreaterThan]"
                />
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn small flat color="gray" @click="closeRating">
            <span v-t="'common.close'" />
          </v-btn>
          <v-btn
            small
            color="primary"
            :disabled="disableButton"
            @click="saveRating"
          >
            <span v-t="'common.save'" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </dialog-wrapper>
</template>

<script>
import ValidationService from '@/services/ValidationService';
import DialogWrapper from '../dialog-wrapper/DialogWrapper.vue';

export default {
  name: 'RatingModal',
  components: { DialogWrapper },
  props: {
    dialog: Boolean,
    ratedDishes: {
      type: Array,
      default: () => [],
    },
    date: {
      type: String,
      default: undefined,
    },
    providerTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hovered: '',
      buttons: [{
        icon: 'sentiment_very_dissatisfied',
        value: 1,
      }, {
        icon: 'sentiment_dissatisfied',
        value: 2,
      }, {
        icon: 'sentiment_neutral',
        value: 3,
      }, {
        icon: 'sentiment_satisfied',
        value: 4,
      }, {
        icon: 'sentiment_very_satisfied',
        value: 5,
      }],
      rules: {
        lengthNotGreaterThan: ValidationService.rules.lengthNotGreaterThan(this.$t('mainComponent.commentMustNotExceed', { count: 500 }), 500),
      },
    };
  },
  computed: {
    disableButton() {
      return this.ratedDishes.length > 0 && (this.ratedDishes.some(d => !d.rating) || this.$refs.comment.some(c => !c.valid));
    },
  },
  methods: {
    async saveRating() {
      this.$emit('saveRating');
    },
    closeRating() {
      this.$emit('closeRating');
    },
  },
};
</script>

<style scoped>
.rating-button >>> .btn__content:before {
  content: none !important;
}

.v-list >>> .v-messages {
  display: unset !important;
}
</style>
